export const ellipses = "...";
const range = (start, end)=>{
    const length = end - start + 1;
    return Array.from({
        length
    }, (_, idx)=>idx + start);
};
const getPageItemsRange = (total, pageSize, currentPage)=>{
    const startMax = pageSize * (currentPage - 1) + 1;
    const endMin = pageSize * currentPage;
    const start = Math.max(startMax, 1);
    const end = Math.min(endMin, total);
    if (start > end) return {
        start: 0,
        end: 0
    };
    return {
        start,
        end
    };
};
export const usePagination = ({ currentPage , itemsPerPage , totalItemsCount  })=>{
    const siblingCount = 3;
    const totalPageCount = Math.ceil(totalItemsCount / itemsPerPage);
    const totalNumberOfPaginationItemsToShow = 10;
    const pageItemsRange = getPageItemsRange(totalItemsCount, itemsPerPage, currentPage);
    const isPageInvalid = currentPage > totalPageCount || currentPage < 1;
    if (totalNumberOfPaginationItemsToShow >= totalPageCount) {
        const allRange = range(1, totalPageCount);
        return {
            items: allRange,
            pageItemsRange,
            isPageInvalid
        };
    }
    const startIndex = Math.max(currentPage - siblingCount, 1);
    const endIndex = Math.min(currentPage + siblingCount, totalPageCount);
    const shouldShowLeftEllipses = startIndex > 2;
    const shouldShowRightEllipses = endIndex < totalPageCount - 2;
    const firstPageIndex = 1;
    const lastPageIndex = totalPageCount;
    if (!shouldShowLeftEllipses && shouldShowRightEllipses) {
        const leftItemCount = siblingCount + 2 * siblingCount;
        const leftRange = range(1, leftItemCount);
        const items = [
            ...leftRange,
            ellipses,
            totalPageCount
        ];
        return {
            items,
            pageItemsRange,
            isPageInvalid
        };
    }
    if (shouldShowLeftEllipses && !shouldShowRightEllipses) {
        const rightItemCount = 3 + 2 * siblingCount;
        const rightRange = range(totalPageCount - rightItemCount + 1, totalPageCount);
        const items1 = [
            firstPageIndex,
            ellipses,
            ...rightRange
        ];
        return {
            items: items1,
            pageItemsRange,
            isPageInvalid
        };
    }
    if (shouldShowLeftEllipses && shouldShowRightEllipses) {
        const middleRange = range(startIndex, endIndex);
        const items2 = [
            firstPageIndex,
            ellipses,
            ...middleRange,
            ellipses,
            lastPageIndex
        ];
        return {
            items: items2,
            pageItemsRange,
            isPageInvalid
        };
    }
    return {
        items: [],
        pageItemsRange: {
            start: 0,
            end: 0
        },
        isPageInvalid
    };
};
